
    import './styles.scoped.css';
    export default {
  "input-adorned-container": "awsui_input-adorned-container_2rhyz_1b71d_9",
  "input": "awsui_input_2rhyz_1b71d_9",
  "input-adorned-container-readonly": "awsui_input-adorned-container-readonly_2rhyz_1b71d_22",
  "input-readonly": "awsui_input-readonly_2rhyz_1b71d_22",
  "root": "awsui_root_2rhyz_1b71d_35",
  "input-invalid": "awsui_input-invalid_2rhyz_1b71d_138",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_1b71d_147",
  "input-warning": "awsui_input-warning_2rhyz_1b71d_150",
  "input-type-search": "awsui_input-type-search_2rhyz_1b71d_162",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_1b71d_175",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1b71d_178",
  "grouped": "awsui_grouped_2rhyz_1b71d_185",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_1b71d_191",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_1b71d_195",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_1b71d_201",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_1b71d_205",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_1b71d_209",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_1b71d_215",
  "grouped-end-action-horizontal-last": "awsui_grouped-end-action-horizontal-last_2rhyz_1b71d_219",
  "grouped-end-action-horizontal-only": "awsui_grouped-end-action-horizontal-only_2rhyz_1b71d_219",
  "grouped-end-action-vertical-first": "awsui_grouped-end-action-vertical-first_2rhyz_1b71d_223",
  "grouped-end-action-vertical-last": "awsui_grouped-end-action-vertical-last_2rhyz_1b71d_223",
  "grouped-end-action-vertical-only": "awsui_grouped-end-action-vertical-only_2rhyz_1b71d_223",
  "input-container": "awsui_input-container_2rhyz_1b71d_228",
  "input-icon-start": "awsui_input-icon-start_2rhyz_1b71d_233",
  "input-icon-end": "awsui_input-icon-end_2rhyz_1b71d_240",
  "input-button-right": "awsui_input-button-right_2rhyz_1b71d_246",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_1b71d_250",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_1b71d_253",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_1b71d_257",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_1b71d_260",
  "inline-label": "awsui_inline-label_2rhyz_1b71d_250",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_1b71d_285",
  "input-adorned-container-disabled": "awsui_input-adorned-container-disabled_2rhyz_1b71d_310",
  "input-adorned-container-invalid": "awsui_input-adorned-container-invalid_2rhyz_1b71d_318",
  "input-adorned-container-warning": "awsui_input-adorned-container-warning_2rhyz_1b71d_331",
  "input-prefix": "awsui_input-prefix_2rhyz_1b71d_345",
  "input-suffix": "awsui_input-suffix_2rhyz_1b71d_346",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_1b71d_359",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_1b71d_368",
  "input-adorned": "awsui_input-adorned_2rhyz_1b71d_9"
};
  